<template>
	<div class="home">
		<div class="home-hero">
			<h1>{{ ii('SEMALT_TOOLS') }}</h1>
		</div>

		<div class="home-pages-box">
			<div class="tool-input-box">
				<s-text-field
					v-model="app.query.q"
					ref="tf"
					prepend-icon="search"
					:placeholder="ii('SEARCH')"
					@change="refreshQuery"
				></s-text-field>
			</div>
			<div class="home-grid">
				<div
					class="home-page-block"
					v-for="page in filteredPages"
					:key="page.id"
				>
					<app-link :to="'/' + page.page">
						<div class="hpb-ico"><i :class="'fa fa-' + page.fa"></i></div>
						<div class="hpb-body">
							<strong>{{ ii(page.label) }}</strong>
							<div class="hpb-desc">{{ descMap[page.page] }}</div>
						</div>
					</app-link>
				</div>
			</div>
		</div>

		<div class="page-text-content content-block" v-html="markdownToHtml(app.texts.content)"></div>
	</div>
</template>

<style lang="less">
.home {
	margin: 0 auto;
	max-width: 1220px;

	.home-hero {
		text-align: center;
		padding: 24px 0 2px;

		h1 {
			margin: 0;
			font-size: 30px;
			font-weight: 800;
			letter-spacing: -.6px;
		}
	}

	.tool-input-box {
		padding: 18px 5px 26px;
		margin: 0 auto;
		max-width: 520px;
	}

	.home-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(258px, 1fr));
		gap: 14px;
	}

	.home-page-block {
		display: block;
		padding: 0;

		a {
			display: flex;
			gap: 14px;
			align-items: flex-start;
			padding: 18px;
			border: 1px solid #e9ecf1;
			border-radius: 13px;
			background: #fff;
			color: #1c2430;
			text-decoration: none;
			transition: transform .15s, box-shadow .15s, border-color .15s;

			&:hover {
				transform: translateY(-2px);
				border-color: #2f6bff;
				box-shadow: 0 8px 24px rgba(47, 107, 255, .10);
			}

			.hpb-ico {
				width: 42px;
				height: 42px;
				flex: none;
				border-radius: 11px;
				background: #eaf0ff;
				color: #2f6bff;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 18px;
			}

			.hpb-body strong {
				display: block;
				font-size: 15px;
				margin-bottom: 3px;
			}

			.hpb-desc {
				color: #6a7383;
				font-size: 13px;
				line-height: 1.4;
			}
		}
	}
}
</style>

<script>
	export default {
		data() {
			return {
				descMap: {}
			};
		},
		computed: {
			filteredPages() {
				if (!this.app.query.q) return this.app.pages;

				let searchVal = this.app.query.q.toLowerCase();

				let pages = this.app.pages.filter(page => {
					let title = this.ii(page.label);
					let desc = this.descMap[page.page] || '';

					let labelFound = title.toLowerCase().includes(searchVal);
					let descFound = desc.toLowerCase().includes(searchVal);

					return labelFound || descFound;
				});

				return pages;
			}
		},
		methods: {
			async loadDescriptions() {
				let map = this.app.pagesDescCache[this.app.lang];
				if (!map) {
					map = await this.get('Page.getPagesDescriptions', this.app.lang);
					this.$set(this.app.pagesDescCache, this.app.lang, map);
				}
				this.descMap = map;
			}
		},
		watch: {
			'app.lang'() {
				this.loadDescriptions();
			}
		},
		mounted() {
			this.loadDescriptions();

			if (!this.app.isMob) this.$refs.tf.focus();
		}
	}
</script>
